import React from 'react';

const Loading = () => {
    return (
        <div className='h-screen m-32 p-36'>
        <button className="btn loading">loading</button>
    </div>
    );
};

export default Loading;